import React from "react";
import { useNavigate } from "react-router-dom";
// import Navbar from "../Navbar";
// import PratiqueBrowser from "../components/pratique/PratiqueBrowser";
import PratiqueBrowser from "./PratiqueBrowser";

const Pratique = () => {
  const navigate = useNavigate();

  const handlePracticeSelect = (practiceId) => {
    navigate(`/pratique/${practiceId}`);
  };

  return (
    <div className="min-h-screen bg-white">
        <PratiqueBrowser onPracticeSelect={handlePracticeSelect} />
    </div>
  );
};

export default Pratique;
